import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-library-activities',
  templateUrl: './library-activities.component.html',
  styleUrls: ['./library-activities.component.scss']
})
export class LibraryActivitiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
